// App Spanish-only (decisión de producto, ver CLAUDE.md "Internacionalización"): el locale
// queda FIJO en 'es', sin selector ni detección de navegador. en/fr/it/pt solo existen como
// almacén de traducciones para revisión futura — no se cargan en el runtime.
import { createI18n } from 'vue-i18n'
import esCommon from '../locales/es/common.json'
import esNav from '../locales/es/nav.json'
import esImports from '../locales/es/imports.json'
import esLegal from '../locales/es/legal.json'
import esCompanyInformation from '../locales/es/companyInformation.json'
import esUploads from '../locales/es/uploads.json'
import esPromotions from '../locales/es/promotions.json'
import esServiceForm from '../locales/es/serviceForm.json'
import { datetimeFormats, numberFormats } from './formats'

export const SUPPORTED_LOCALES = ['es', 'en', 'fr', 'it', 'pt'] as const
export type SupportedLocale = (typeof SUPPORTED_LOCALES)[number]
export const DEFAULT_LOCALE: SupportedLocale = 'es'

const esMessages = { common: esCommon, nav: esNav, imports: esImports, legal: esLegal, companyInformation: esCompanyInformation, uploads: esUploads, promotions: esPromotions, serviceForm: esServiceForm }

export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: DEFAULT_LOCALE,
  fallbackLocale: DEFAULT_LOCALE,
  messages: { es: esMessages },
  datetimeFormats,
  numberFormats
})

export type AppMessageSchema = typeof esMessages
